import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";

export default function Verify(prop) {
    let navigate = useNavigate();

    //eyJzdWIiOjE0MDk4MDAwMDgxOTAsInBpZCI6MTQwOTgwMDAwODE5MCwiZ2l2ZW5fbmFtZSI6Ilx1MGUyYVx1MGUzOFx1MGUyM1x1MGUwYVx1MGUzMlx1MGUxNVx1MGUzNCIsImdpdmVuX25hbWVfZW4iOiJTdXJhY2hhcnQiLCJmYW1pbHlfbmFtZSI6Ilx1MGUxN1x1MGU0OVx1MGUzMlx1MGUyN1x1MGUyMVx1MGUxOVx1MGUxNVx1MGUyM1x1MGUzNSIsImZhbWlseV9uYW1lX2VuIjoiVG93bW9udHJlZSIsInRpdGxlVGgiOiJcdTBlMTlcdTBlMzJcdTBlMjIiLCJ0aXRsZUVuIjoiTXIuIn0=
    let {slug} = useParams();

    let [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        document.title = 'ยืนยันผู้ใช้งาน | NCSA';


        (async function() {
            try {
                if(slug) {
                    let decode = Utils.decodeItem(slug);
                    let pid = decode.pid;
                    let title_th = decode.title_th;
                    let given_name = decode.given_name;
                    let family_name = decode.family_name;
                    let given_name_en = decode.given_name_en;
                    let family_name_en = decode.family_name_en;
                    const result = await checkIdcard(pid);
                    if(result) {
                        setIsLoading(false);
                        if(result.status === 'success') {
                            localStorage.setItem(Utils.LOCAL_STORAGE_KEY, JSON.stringify(result));
                            window.location.href = (prop.lang === 'en' ? '/en':'/') + 'profile';
                        }
                        else {
                            window.location.href = (prop.lang === 'en' ? '/en/register/' + slug:'/register/' + slug);
                        }
                    }
                }
                else {
                    window.location.href = (prop.lang === 'en' ? '/en':'/');
                }
            } catch (e) {
                //
            }
        })();
    }, []);

    async function checkIdcard(idcard) {
        const response = await fetch(Config.apiUrl +'/member/checkIdcard', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                idcard: idcard
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner my-5 text-center">
                <span className={"spinner-grow mt-5 m-auto" + (isLoading ? '' : 'd-none')}></span>
                <h3>กำลังตรวจสอบข้อมูล...</h3>
                <h3>Verifying...</h3>
            </div>
        </>
    );
} 